import React, { FC } from 'react';
import { MicroFrontend, SpecificMicroFrontendProps } from '../../core';
import { constants } from './constants';
import { ControlTowerWidgetMicroFrontendProps } from './ControlTowerWidget.types';
import { ControlTowerGlobalPanelMicroFrontendProps } from './ControlTowerGlobalPanel.types';

export type NotificationsMicroFrontendProps = SpecificMicroFrontendProps & {
  isAppMobile?: boolean;
};

export const NotificationsMicroFrontend: FC<NotificationsMicroFrontendProps> = ({
  entryPointUrl,
  isAppMobile,
  isMobile,
  isTablet,
  isSmartTV,
  ...props
}) => {
  // Determine which exposed path to use based on device type
  const exposedPath = isAppMobile
    ? constants.MFE_NOTIFICATIONS_MOBILE_EXPOSED_PATH
    : constants.MFE_NOTIFICATIONS_EXPOSED_PATH;

  return (
    <MicroFrontend
      entryPointUrl={entryPointUrl}
      name={constants.MFE_NOTIFICATIONS_NAME}
      exposedPath={exposedPath}
      isAppMobile={isAppMobile}
      isMobile={isMobile}
      isTablet={isTablet}
      isSmartTV={isSmartTV}
      {...props}
    />
  );
};

export const ControlTowerWidgetMicroFrontend: FC<ControlTowerWidgetMicroFrontendProps> = ({
  entryPointUrl,
  ...props
}) => {
  return (
    <MicroFrontend
      entryPointUrl={entryPointUrl}
      name={constants.MFE_NOTIFICATIONS_NAME}
      exposedPath={constants.MFE_NOTIFICATIONS_CONTROL_TOWER_WIDGET_EXPOSED_PATH}
      {...props}
    />
  );
};

export const ControlTowerGlobalPanelMicroFrontend: FC<
  ControlTowerGlobalPanelMicroFrontendProps
> = ({ entryPointUrl, ...props }) => {
  return (
    <MicroFrontend
      entryPointUrl={entryPointUrl}
      name={constants.MFE_NOTIFICATIONS_NAME}
      exposedPath={constants.MFE_NOTIFICATIONS_CONTROL_TOWER_GLOBAL_PANEL_EXPOSED_PATH}
      {...props}
    />
  );
};
